<template>
  <v-container fluid class="webConPage-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการเนื้อหาเว็บไซต์</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConPages.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [5, 10, 15, 50,-1]
                }"
                :items="webConPages"
                :search="search"
                sort-by="pages_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6" v-if="state=='editForm'">
                  <v-text-field
                      v-model="editForm.page_url"
                      :counter="45"
                      :rules="editForm.textReqRules.concat(editForm.URLRules)"
                      label="URL(ID) เนื้อหาเว็บไซต์"
                      required
                      disabled
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6" v-else>
                  <v-text-field
                      v-model="editForm.page_url"
                      :counter="45"
                      :rules="editForm.textReqRules.concat(editForm.URLRules)"
                      label="URL(ID) รหัสเนื้อหาเว็บไซต์"
                      required
                  ></v-text-field>
                </v-col>

                <v-row align="center">

                  <v-col class="d-flex" cols="12" sm="4">

                    <v-switch
                        v-model="editForm.switch_lang"
                        inset
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="เพิ่มเนื้อหาภาษา [EN]"
                        required
                    ></v-switch>


                  </v-col>

                </v-row>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.page_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อเว็บไซต์ (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.page_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อเว็บไซต์ (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center">

                <v-col>

                  <v-chip

                      color="success"
                      class="ma-2"
                  >
                    เนื้อหาเว็บไซต์ (TH)
                  </v-chip>
                  <v-chip
                      @click="showUploads"
                      color="info"
                      class="ma-2"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>

                    อัพโหลดไฟล์/รูป ประกอบเนื้อหา
                  </v-chip>

                  <editor
                      id="page_content_th"
                      v-model="editForm.page_content_th"
                      :api-key=tiny.api
                      :init="{
                        convert_urls:true,
relative_urls:false,
remove_script_host:false,
                       // images_upload_url: baseURLApi+'/uploads_tinymce',
                       height: 500,
                       menubar: true,
                       plugins: tiny.plugins,
                       toolbar: tiny.toolbar,
                       valid_elements : '*[*]', //tag css other
                       forced_root_block: 'div'
                      }"
                              />


                </v-col>


              </v-row>

              <v-row align="center" v-if="editForm.switch_lang=='Y'">

                <v-col>

                  <v-chip

                      color="secondary"
                      class="ma-2"
                  >
                    เนื้อหาเว็บไซต์ (EN)
                  </v-chip>

                  <v-chip
                      @click="showUploads"
                      color="info"
                      class="ma-2"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>

                    อัพโหลดไฟล์/รูป ประกอบเนื้อหา
                  </v-chip>

                  <editor
                      id="page_content_en"
                      v-model="editForm.page_content_en"
                      :api-key=tiny.api
                      :init="{
                        convert_urls:true,
relative_urls:false,
remove_script_host:false,
                       height: 500,
                       menubar: true,
                       plugins: tiny.plugins,
                       toolbar: tiny.toolbar,
                       valid_elements : '*[*]', //tag css other
                       forced_root_block: 'div'
                      }"
                  />
                </v-col>

              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import Editor from '@tinymce/tinymce-vue';
import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';

export default {
  name: 'ConPageManagement',
  data() {
    return {
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      snackbar: null,
      dialog_upload: false,
      search: '',
      selected: [],
      headers: [
        {
          text: 'URL(ID)',
          align: 'start',
          value: 'page_url',
        },
        {text: 'หลายภาษา', value: 'switch_lang'},
        {text: 'ชื่อ(TH)', value: 'page_title_th'},
        {text: 'ชื่อ(EN)', value: 'page_title_en'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        page_url: '',
        URLRules: validateRules.URLRules,
        textReqRules: validateRules.textReqRules,
        page_title_th: '',
        page_title_en: '',
        page_content_th: '',
        page_content_en: '',
        switch_lang: 'N',
        active: 'N',
      },
    }
  },
  components: {
    'editor': Editor, // <- Important part
    UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_pages', ['webConPages', "isReceiving", "isDeleting", "idToDelete", "webConPageMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConPageMessage() {

      if (this.webConPageMessage !== '') {
        this.notification = this.webConPageMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConPagesRequest();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_pages',
        [
          "getWebConPagesRequest",
          "deleteWebConPageRequest",
          "updateWebConPageRequest",
          "createWebConPageRequest"
        ]
    ),
    addItem() {
      this.editedIndex = -1 //index = -1 add

      this.editForm.page_url = null;
      this.editForm.page_title_th = null;
      this.editForm.page_title_en = null;
      this.editForm.page_content_th = null;
      this.editForm.page_content_en = null;
      this.editForm.switch_lang = 'N';
      this.editForm.active = 'Y';
      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.webConPages.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.pages_id = item.pages_id;
      this.editForm.page_url = item.page_url;
      this.editForm.page_title_th = item.page_title_th;
      this.editForm.page_title_en = item.page_title_en;
      this.editForm.page_content_th = item.page_content_th;
      this.editForm.page_content_en = item.page_content_en;
      this.editForm.switch_lang = item.switch_lang;
      this.editForm.active = item.active;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConPageRequest({pages_id: item.pages_id})


    },
    close() {

      if (this.errorMessage == false || this.webConPageMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConPages[this.editedIndex], this.editForm)
            :
            this.updateWebConPageRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConPages.push(this.editForm)
            :
            this.createWebConPageRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    async beforeMount() {
    },

  },
}
</script>

<style src="./ConPageManagement.scss" lang="scss"/>
